import cardModel from '../static/card-model';
import { _get, _getAxios } from './serviceMain';

export function getUserCards() {

     const url = '/v3/account/cards';

     return _getAxios(url, "GET_CARDS_TIME", "cards");

};